<template>	
	<div class="col-12 inMiddle-area table-responsives">
		<table class="table customize">
			<thead>
				<tr>
					<th>{{$t('dw_acc_fund_accountId')}}</th>
					<th>{{$t('dash_currency')}}</th>
					<th>{{$t('dash_Platform')}}</th>
					<th>{{$t('Dlist_demoLive')}}</th>
					<th>{{$t('Dlist_accountType')}}</th>
					<th>{{$t('Dlist_leverage')}}</th>
					<th></th> 
				</tr>
			</thead>
			<account-list-table v-if="(!pageLoader1 && demoAccountList != '' && demoAccountList.totalRecords > 0)" :accountlist="demoAccountList.records" :pageLoader="pageLoader1" :listType="'demo'" :pageLimit="pageLimit" :page="page" />
			<loader-component :pageloader_value="pageLoader1" :type="'table'" :colspan="col_span" :list="demoAccountList" v-else></loader-component>
		</table> 
		<pagination :getList="demoAccountList" :limit="pageLimit" v-if="demoAccountList.totalRecords > 10"></pagination>
	</div>
</template>
<script>
	import account_list_table from '../shared/tradingAccounts/account-list-table'
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    export default {
        name: 'Demo-Account-List',
        mixins: [fxViewMixins],
        data() {
            return { 
                //===========prop in loader component=======
                col_span : 7,
            	//============message and loader ===========
                pageLoader : false,
                pageLimit : '10',
				page : '1',
                //==========================================
                account_id : '',
				act_account_id : '',
				
				
				showButtonDetailInfo : ''
            }
        },
		props:['pageLoader1'],
		components: {
            accountListTable : account_list_table
        },
        methods:{
        	
        	detailDiv(index,getData) {
        		/*this.account_id = account_id
				this.act_account_id = act_account_id*/
				if(getData == 'div'){
					var element = document.getElementById(getData+index)
					if ($(element).hasClass('hide')){
						$(element).removeClass('hide');
					}else{
						$(element).addClass('hide');
					} 
				}else{
					if(parseInt(this.showButtonDetailInfo) == index){
						this.showButtonDetailInfo = ''
					}else{
						this.showButtonDetailInfo = index
					}
				}
            },
        	
        	
        },
		mounted() { 
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.dotAreaForButton').length){
                    _that.showButtonDetailInfo = ''
                }
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/demo_account_list.vue